import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import Resumen from "./Resumen";
import { exportCSVFile } from "../utilities/exportCSVFile";

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}
interface IState {
  listaCupon: any;
  globalFilter: any;
  presentaciones: any;
  presentacionSugerida: any;
  selectedMultiPresentacionesProd: any;
  productos: any;
  disabled: boolean;
  vtasComercio: any;
  vtasComercioSinDesc: any;
  devolucionDescuentos: any;
  comisionPrograma: any;
  ajusteCtaCorriente: any;
  impuestos: any;
  bruto: any;
  neto: any;
  acreditacionVta: any;
  lts: any;
}

interface IProps {
  listaCupon: any[];
  redId: any;
}

const TransaccionesAsociadas = (props: IProps) => {
  const [state, setState] = useState<IState>({
    listaCupon: props.listaCupon,
    globalFilter: null,
    presentaciones: [],
    selectedMultiPresentacionesProd: null,
    presentacionSugerida: null,
    productos: null,
    disabled: true,
    vtasComercio: 0,
    vtasComercioSinDesc: 0,
    devolucionDescuentos: 0,
    comisionPrograma: 0,
    ajusteCtaCorriente: 0,
    impuestos: 0,
    neto: 0,
    bruto: 0,
    acreditacionVta: 0,
    lts: 0,
  });
  const [loadResume, setLoadResume] = useState(false);
  const [selectedMultiPresentaciones, setSelectedMultiPresentaciones] =
    useState(null);
  const [selectedPresentaciones, setSelectedPresentaciones] = useState([]);
  const dt = useRef<DataTable>(null);

  useEffect(() => {
    let pres = props.listaCupon.map((e) => {
      return e.numeroPresentacion;
    });

    let presentaciones = pres
      .filter((item, index) => {
        return pres.indexOf(item) === index;
      })
      .map((e) => {
        return { numeroPresentacion: e };
      });

    let prod = props.listaCupon.map((e) => {
      return e.servicio;
    });

    let productos = prod
      .filter((item, index) => {
        return prod.indexOf(item) === index;
      })
      .map((e) => {
        return { servicio: e };
      });

    setState({ ...state, presentaciones, productos });
    setLoadResume(true);
  }, []);

  useEffect(() => {
    loadResume && cargarResumen(props.listaCupon);
  }, [loadResume]);

  //#region "onChanges"
  const onChangeddlPresentaciones = (e: any) => {
    let a = e.value;
    let selectedPresentaciones = [];
    let p = state.listaCupon.slice();
    setSelectedMultiPresentaciones(a);
    if (a) {
      selectedPresentaciones = p.filter((e: any) => {
        if (e.numeroPresentacion === a.numeroPresentacion) {
          return e;
        }
      });
    }

    setSelectedPresentaciones(selectedPresentaciones);

    if (selectedPresentaciones.length > 0) {
      cargarResumen(selectedPresentaciones);
    } else {
      cargarResumen(state.listaCupon);
    }
  };

  const onChangeDdlProductos = (e: any) => {
    let a = e.value;
    let selectedPresentaciones = [];
    setState({ ...state, selectedMultiPresentacionesProd: a });
    if (a) {
      let p = state.listaCupon.slice();
      selectedPresentaciones = p.filter((e: any) => {
        if (e.servicio === a.servicio) {
          return e;
        }
      });
    }
    setSelectedPresentaciones(selectedPresentaciones);

    if (selectedPresentaciones.length > 0) {
      cargarResumen(selectedPresentaciones);
    } else {
      cargarResumen(props.listaCupon);
    }
  };

  const cargarResumen = (presentaciones: any) => {
    if (presentaciones.length > 0) {
      /*
            a.	Total  Bruto Margen Calculado = Ventas en comercio Bruto + Devolución Descuentos Bruto - Comisión Programa Bruto
            b.	Total  Neto Margen Calculado = Ventas en comercio Neto + Devolución Descuentos Neto - Comisión Programa Neto
            c.	Acreditación por Ventas Bruto = Suma Ventas en Comercio Bruto
            d.	Acreditación por Ventas Neto = Acreditación por Ventas informado en input Raizen
            e.	Ventas comercio Sin Desc = Suma por presentacion trd_monto_sin_desc
             
             */
      let vtasSinDesc = [...presentaciones]
        .filter((e) => e.tipoMovimiento === "Ventas Sin Desc.($ Surt.)")
        .map((e) => e.importeBruto)
        .reduce((a, b) => a + b, 0);
      let vtasEnComercioBruto = [...presentaciones]
        .filter((e) => e.tipoMovimiento === "Ventas Con Desc.")
        .map((e) => e.importeBruto)
        .reduce((a, b) => a + b, 0);
      let devolucionDescuentosBruto = [...presentaciones]
        .filter((e) => e.tipoMovimiento.startsWith("Devo"))
        .map((e) => e.importeBruto)
        .reduce((a, b) => a + b, 0);
      let comisionProgramaBruto = [...presentaciones]
        .filter((e) => e.tipoMovimiento.startsWith("Comi"))
        .map((e) => e.importeBruto)
        .reduce((a, b) => a + b, 0);
      let vtasEnComercioNeto = [...presentaciones]
        .filter((e) => e.tipoMovimiento === "Ventas Con Desc.")
        .map((e) => e.importeNeto)
        .reduce((a, b) => a + b, 0);
      let devolucionDescuentosNeto = [...presentaciones]
        .filter((e) => e.tipoMovimiento.startsWith("Devo"))
        .map((e) => e.importeNeto)
        .reduce((a, b) => a + b, 0);
      let comisionProgramaNeto = [...presentaciones]
        .filter((e) => e.tipoMovimiento.startsWith("Comi"))
        .map((e) => e.importeNeto)
        .reduce((a, b) => a + b, 0);
      let acreditacionVtasBruto = vtasEnComercioBruto;
      let acreditacionVtasNeto = [...presentaciones]
        .filter((e) => e.tipoMovimiento.startsWith("Acre"))
        .map((e) => e.importeNeto)
        .reduce((a, b) => a + b, 0);

      //Items

      //Item Ventas en Comercio:
      let vtasComercio = vtasEnComercioBruto;
      let vtasComercioSinDesc = vtasSinDesc;
      //Item Devolución descuentos:
      let devolucionDescuentos = devolucionDescuentosNeto;
      //Item Comision Programa:
      let comisionPrograma = comisionProgramaNeto;
      //Item Ajuste Cta. Corriente:
      let ajusteCtaCorriente = [...presentaciones]
        .filter((e) => e.tipoMovimiento === "Ajuste Cta. Cte.")
        .map((e) => e.importeBruto)
        .reduce((a, b) => a + b, 0);
      //Item Acreditación por ventas:
      let acreditacionVta = acreditacionVtasNeto;
      //Item Impuestos:
      let impuestosDevolucionDescuentos =
        devolucionDescuentosBruto - devolucionDescuentosNeto;
      let impuestosComisionPrograma =
        comisionProgramaBruto - comisionProgramaNeto;
      let impuestosAcreditacionPorVentas =
        acreditacionVtasNeto > 0
          ? acreditacionVtasBruto - acreditacionVtasNeto
          : 0;

      let impuestos =
        impuestosDevolucionDescuentos -
        impuestosComisionPrograma +
        impuestosAcreditacionPorVentas;

      //MArgen Calculado

      let bruto = 0;
      let neto = 0;
      //no lo muestra si la comision no esta porque es mensual y letian los datos si filtra por presentacion
      if (comisionProgramaNeto > 0) {
        //Total  Bruto Margen Calculado = Ventas en comercio Bruto + Devolución Descuentos Bruto - Comisión Programa Bruto
        bruto =
          vtasComercio + devolucionDescuentosBruto - comisionProgramaBruto;
        //Total  Neto Margen Calculado = Ventas en comercio Neto + Devolución Descuentos Neto - Comisión Programa Neto
        neto =
          acreditacionVtasNeto +
          devolucionDescuentosNeto -
          comisionProgramaNeto;
        if (bruto <= 0) {
          bruto = 0;
          neto = 0;
        }
      }
      //Total  lts  =  suma lts de la trd
      let lts = [...presentaciones]
        .filter((e) => e.tipoMovimiento === "Ventas Con Desc.")
        .map((e) => e.cantidad)
        .reduce((a, b) => a + b, 0);
      setState({
        ...state,
        vtasComercio,
        vtasComercioSinDesc,
        devolucionDescuentos,
        comisionPrograma,
        ajusteCtaCorriente,
        impuestos,
        neto,
        lts,
        acreditacionVta,
        bruto,
      });
    }
  };
  //#endregion "onChanges"
  //#region "Exporta el csv"
  const onExport = (e: any) => {
    //trae el array que tiene la tabla filtrada o no
    // state.selectedPresentaciones.length > 0 ? state.selectedPresentaciones :
    let a = [];
    if (selectedPresentaciones.length > 0) {
      a = selectedPresentaciones.slice();
    } else {
      a = props.listaCupon.slice();
    }

    let b = a.map((e: any) => {
      let date = new Date(e.fechaPresentacion);
      if (!isNaN(date.getTime())) {
        let dia = date.getDate();
        let mes = date.getMonth();
        let anio = date.getFullYear();
        if (e.tipoMovimiento.startsWith("Comi")) {
          if (mes <= 8) {
            e.fechaPresentacion = "0" + (mes + 1).toString() + "/" + anio;
          } else {
            e.fechaPresentacion = (mes + 1).toString() + "/" + anio;
          }
        } else {
          if (mes <= 8) {
            e.fechaPresentacion =
              dia + "/" + "0" + (mes + 1).toString() + "/" + anio;
          } else {
            e.fechaPresentacion = dia + "/" + (mes + 1).toString() + "/" + anio;
          }
        }
      }

      let n = parseInt(e.cantidad);
      e.cantidad = n;

      switch (e.tipoMovimiento) {
        case "Devolución Descuentos":
          e.tipoMovimiento = "Devolucion Descuentos";
          break;
        case "Comisión programa":
          e.tipoMovimiento = "Comision programa";
          break;
        case "Acreditación por Ventas":
          e.tipoMovimiento = "Acreditacion por Ventas";
          break;
        default:
      }
      switch (e.numeroDocumento) {
        case null:
          e.numeroDocumento = "";
          break;

        default:
      }
      switch (e.producto) {
        case null:
          e.producto = "";
          break;
        case "-":
          e.producto = "";
          break;

        default:
      }
      switch (e.servicio) {
        case null:
          e.servicio = "";
          break;
        case "-":
          e.servicio = "";
          break;

        default:
      }
      switch (e.unidadMedida) {
        case null:
          e.unidadMedida = "";
          break;
        case "-":
          e.unidadMedida = "";
          break;

        default:
      }
      let comercio = props.redId;

      return {
        comercio: comercio,
        tipoMovimiento: e.tipoMovimiento,
        fechaPresentacion: e.fechaPresentacion,
        numeroPresentacion: e.numeroPresentacion,
        numeroDocumento: e.numeroDocumento,
        servicio: e.servicio,
        importeBruto: e.importeBruto,
        impuestos: e.impuestos,
        importeNeto: e.importeNeto,
        cantidad: e.cantidad,
        unidadMedida: e.unidadMedida,
      };
    });
    // arma los encabezados de las columnas de la tabla
    const headers = {
      comercio: "Comercio",
      tipoMovimiento: "Tipo Movimiento",
      fechaPresentacion: "Fecha Pres",
      numeroPresentacion: "Presentacion",
      numeroDocumento: "Doc. CS Online",
      servicio: "Producto",
      importeBruto: "Bruto",
      impuestos: "Impuestos",
      importeNeto: "Neto",
      cantidad: "Cant",
      unidadMedida: "UM",
    };

    //llama a la funcion que exporta
    exportCSVFile(headers, b, "DetalleReembolsosCsv");
  };

  //#endregion "Exporta el csv"

  //#region "Encabezado de tabla"
  const tableHeader = () => {
    return (
      <div className="p-panel-titlebar">
      <div className="p-grid p-justify-between p-align-center ">
        <div className="p-col-4">Detalle de reembolsos </div>

        {props.listaCupon.length > 0 ? (
          <div className="p-col-8 ">
            <div
              className="d-inline p-col-6 "
              title="Busca en todos los campos"
              style={{ textAlign: "left" }}
            >
              <i className="pi pi-search "></i>

              <InputText
                disabled={props.listaCupon.length > 0 ? false : true}
                type="search"
                onInput={(e: any) =>
                  setState({ ...state, globalFilter: e.target.value })
                }
                placeholder="Busqueda global..."
                size={20}
              />
            </div>
            <div
              className="d-inline ml-2 p-col-6"
              title="Exportar tabla a .csv"
              style={{ textAlign: "left" }}
            >
              <Button
                disabled={props.listaCupon.length > 0 ? false : true}
                type="button"
                icon="pi pi-external-link"
                iconPos="left"
                label="CSV"
                onClick={(e) => onExport(e)}
              ></Button>
            </div>
            {props.listaCupon.length > 0 &&
            !state.selectedMultiPresentacionesProd ? (
              <div
                className="d-inline ml-2 p-col-12"
                title="Filtra por número de presentación"
                style={{ textAlign: "left" }}
              >
                <Dropdown
                  disabled={
                    props.listaCupon.length > 0 &&
                    !state.selectedMultiPresentacionesProd
                      ? false
                      : true
                  }
                  id="ddlPresentaciones"
                  className="text-wrap  mt-0"
                  value={selectedMultiPresentaciones}
                  options={state.presentaciones}
                  onChange={(e) => onChangeddlPresentaciones(e)}
                  optionLabel="numeroPresentacion"
                  placeholder="Filtrar Presentación..."
                  style={
                    props.listaCupon.length > 0 &&
                    !state.selectedMultiPresentacionesProd
                      ? { width: "12em" }
                      : { width: "12em" }
                  }
                  filter={true}
                  filterBy="numeroPresentacion"
                  showClear={true}
                />
              </div>
            ) : (
              ""
            )}

            {props.listaCupon.length > 0 && !selectedMultiPresentaciones ? (
              <div
                className="d-inline ml-2 p-col-12"
                title="Filtra por Producto"
                style={{ textAlign: "left" }}
              >
                <Dropdown
                  disabled={
                    props.listaCupon.length > 0 && !selectedMultiPresentaciones
                      ? false
                      : true
                  }
                  id="ddlProductos"
                  className="text-wrap  mt-0"
                  value={state.selectedMultiPresentacionesProd}
                  options={state.productos}
                  onChange={(e) => onChangeDdlProductos(e)}
                  optionLabel="servicio"
                  placeholder="Filtrar Producto..."
                  style={
                    props.listaCupon.length > 0 && !selectedMultiPresentaciones
                      ? { width: "12em" }
                      : { width: "22em" }
                  }
                  filter={true}
                  filterBy="servicio"
                  showClear={true}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      </div>
    );
  };
  //#endregion "Encabezado de tabla"

  //#region "formato campos de tabla"
  // achica la letra del encabezado
  const colHeader = (texto: string) => {
    return (
      <div>
        <small className="strong">{texto}</small>
      </div>
    );
  };

  //Retorna texto pequeño
  const bodySmall = (props: any) => {
    if (props) {
      if (props === "-") {
        return <small className="d-flex justify-content-start">{""}</small>;
      } else {
        return <small className="d-flex justify-content-start">{props}</small>;
      }
    }
  };

  const bodySmallComercio = (props: any) => {
    if (props) {
      if (props === "-") {
        return <small className="d-flex justify-content-center">{"-"}</small>;
      } else {
        return <small className="d-flex justify-content-center">{props}</small>;
      }
    }
  };

  const bodyComercioHeader = (props: any) => {
    if (props) {
      if (props === "-") {
        return <span className="d-flex justify-content-center">{""}</span>;
      } else {
        return <span className="d-flex justify-content-center">{props}</span>;
      }
    }
  };

  const bodyCant = (props: any) => {
    if (props) {
      let n = parseFloat(props);

      return (
        <small className="d-flex justify-content-end">
          {n.toLocaleString("es-MX", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </small>
      );
    }
  };

  //Retorna texto pequeño
  const bodyNumeroDoc = (props: any) => {
    if (props) {
      return <small className="d-flex justify-content-center">{props}</small>;
    } else {
      return <small className="d-flex justify-content-center">{""}</small>;
    }
  };

  //Retorna dd-mm
  const bodyFechPres = (props: any) => {
    console.log("bodyFechPres");
    let date = new Date(props.fechaPresentacion);
    const months = [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ];

    const formatDate = (date: Date) => {
      let formatted_date = "";
      if (isNaN(date.getTime())) {
        formatted_date = props.fechaPresentacion;
      } else {
        let m = date.getMonth();
        let mes = "";
        if (m <= 8) {
          mes = "0" + (m + 1);
        } else {
          mes = m.toString();
        }
        formatted_date = mes + "/" + date.getFullYear();
      }

      return formatted_date;
    };

    if (props.tipoMovimiento.startsWith("Comi")) {
      return (
        <small className="d-flex justify-content-center">
          {formatDate(date)}
        </small>
      );
    }

    if (props) {
      return (
        <small className="d-flex justify-content-center">
          {isNaN(date.getTime())
            ? props.fechaPresentacion
            : date.toLocaleDateString("en-GB")}
        </small>
      );
    }
  };

  const bodyCurrencySmall = (props: any) => {
    if (props) {
      let n = parseFloat(props);

      return (
        <div className="d-flex justify-content-between">
          <small>{"$ "}</small>

          <small>
            {n.toLocaleString("es-MX", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </small>
        </div>
      );
    }
  };
  //#endregion

  return (
    <div className="row">
      {props.listaCupon.length > 0 ? <Resumen state={state} /> : ""}
      <div className="datatable-paginator-demo col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
        <Panel headerTemplate={tableHeader()}>
          <DataTable
            ref={dt}
            csvSeparator=";"
            exportFilename="presentaciones"
            dataKey="id"
            value={
              selectedPresentaciones.length > 0
                ? selectedPresentaciones
                : props.listaCupon
            }
            sortMode="multiple"
            globalFilter={state.globalFilter}
            paginator={true}
            rows={25}
            scrollable={true}
            emptyMessage="No se encontraron registros"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            rowsPerPageOptions={[10, 25, 50]}
          >
            <Column
              body={(e: any) => bodySmallComercio(props.redId)}
              header={bodyComercioHeader(colHeader("Comercio"))}
              style={{ width: "5em" }}
            />
            <Column
              field="tipoMovimiento"
              body={(e: any) => bodySmall(e.tipoMovimiento)}
              header={colHeader("Tipo Movimiento")}
              style={{ width: "10em" }}
            />
            <Column
              field="fechaPresentacion"
              body={bodyFechPres}
              header={colHeader("Fecha Pres")}
              style={{ width: "4em" }}
            />
            <Column
              field="numeroPresentacion"
              body={(e: any) => bodySmallComercio(e.numeroPresentacion)}
              header={colHeader("# Pres.")}
              style={{ width: "5em" }}
            />
            <Column
              field="numeroDocumento"
              body={(e: any) => bodyNumeroDoc(e.numeroDocumento)}
              header={colHeader("Doc CS Online")}
              style={{ width: "7em" }}
            />
            {/*               <Column field="producto" body={(e: any) => bodySmall(e.producto)} header={colHeader("Prod Edenred")} />*/}
            <Column
              field="servicio"
              body={(e: any) => bodySmall(e.servicio)}
              header={colHeader("Producto")}
              style={{ width: "10em" }}
            />
            <Column
              field="importeBruto"
              body={(e: any) => bodyCurrencySmall(e.importeBruto)}
              header={colHeader("Bruto")}
              style={{ width: "6em" }}
            />
            <Column
              field="impuestos"
              body={(e: any) => bodyCurrencySmall(e.impuestos)}
              header={colHeader("Impuestos")}
              style={{ width: "6em" }}
            />
            <Column
              field="importeNeto"
              body={(e: any) => bodyCurrencySmall(e.importeNeto)}
              header={colHeader("Neto")}
              style={{ width: "6em" }}
            />
            <Column
              field="cantidad"
              body={(e: any) => bodyCant(e.cantidad)}
              header={colHeader("Cant")}
              style={{ width: "4em" }}
            />
            <Column
              field="unidadMedida"
              body={(e: any) => bodySmallComercio(e.unidadMedida)}
              header={colHeader("UM")}
              style={{ width: "4em" }}
            />
          </DataTable>
        </Panel>
      </div>
    </div>
  );
};

export default TransaccionesAsociadas;
